import {TBusinessRole} from "../../../models/user.model"

export const IMPORTANTANCE_COLORS = new Map<string, string>([
    ['NORMAL', 'rgba(170, 179, 189, 1)'],
    ['MIDDLE', 'rgba(78, 128, 185, 1)'],
    ['IMPORTANT', 'rgba(59, 136, 150, 1)'],
])
export const ROLES_ICONS_MAP = new Map<TBusinessRole, string>([
    ['executor', 'build'],
    ['responsible', 'assignment_ind'],
    ['observer', 'visibility'],
    ['observer_contract', 'business_center'],
])
export const OBJECT_COLLUMS_MAP_TASK = new Map<string, string>([
    ['status_current', 'status_current.label'],
    ['task_type', 'task_type.name'],
])